import { FormattedMessage } from "react-intl";

import { useProofRebrand } from "util/feature_detection";
import { Heading } from "common/core/typography";

import Styles from "./index.module.scss";

type HeaderProps = {
  name: string;
};

export function Header({ name }: HeaderProps) {
  const isProof = useProofRebrand();
  return (
    <div className={Styles.header}>
      <Heading level="h1" textStyle="headingSix" className={Styles.welcome}>
        {isProof ? (
          <FormattedMessage
            id="7604c452-c55a-4592-a087-a5ca57d894b5"
            defaultMessage="Welcome to Proof, {name}."
            values={{ name }}
          />
        ) : (
          <FormattedMessage
            id="1a40b8d4-d073-40a7-a731-bf6f382637eb"
            defaultMessage="Welcome to Notarize, {name}."
            values={{ name }}
          />
        )}
      </Heading>
      <Heading level="h2" textStyle="headingTwo">
        <FormattedMessage
          id="a3dd173b-e300-4b3e-8035-581b3ae28195"
          defaultMessage="Let's help you get started"
        />
      </Heading>
    </div>
  );
}
